import React from 'react'
import { useForm } from "react-hook-form"
import styles from './feedbackForm.module.css';
import { Button } from "../../ui/button/Button"
import { useMutation } from '@tanstack/react-query';
import { authApi } from '../../../api/authMutation/authApi';
import { queryClient } from '../../../api/queryClient';
import { useUserStore } from '../../../stores/useUserStore';
export function FeedbackForm() {

    const { user } = useUserStore();

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();


    const { mutate, error, isPending } = useMutation({
        mutationFn: (questionData) => {
            return authApi.thread(questionData);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['thread'] })
            reset();
        }
    })


    const onSubmit = (data) => {
        mutate(data);
    };
    return (
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <div className={styles.formHeader}>Ваш вопрос</div>
            <div className={styles.formGroup}>
                <div>
                    <input id='author' className={`${styles.input} ${errors.author && styles.errorInput}`} type="text" placeholder='Введите ваше имя' {...register('author', {
                        required: 'Это поле обязательно',
                        minLength: {
                            value: 2,
                            message: 'Минимум 2 символа'
                        }
                    })} />
                    {(errors?.author || error) && (
                        <span className={styles.error}>
                            {errors?.author?.message || error?.message || "Непредвиденная ошибка"}
                        </span>
                    )}
                    <div className={styles.input_wrapper}>
                        <textarea
                            placeholder="Введите ваш вопрос"
                            className={`${styles.input} ${errors.text && styles.errorInput}`}
                            {...register('text', { required: 'Это поле обязательно' })}
                        />
                        {(errors.text || error) && (
                            <span className={styles.error}>
                                {errors.text?.message || error?.message || "Непредвиденная ошибка"}
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <div>
                <Button type="submit" disabled={isPending} variant={'dark-blue'}>
                    Задать вопрос
                </Button>

            </div>
        </form>
    );
}
